/**
 * The one phone formatter (People Part 5 close). Keys are stored E.164 (`+13135550123`); a
 * screen shows a North American number as `(313) 555-0123`; any other number stays as stored —
 * a country-code table is not a guess this formatter makes. Never a second formatter.
 */
export function formatPhone(e164: string): string {
  const s = e164.trim();
  const na = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(s);
  if (na) return `(${na[1] ?? ''}) ${na[2] ?? ''}-${na[3] ?? ''}`;
  return s;
}

/** An email as a screen shows it: lower-cased, trimmed. The key itself keeps what was typed. */
export function formatEmail(raw: string): string {
  return raw.trim().toLowerCase();
}
